<template>
    <div class="case_list" v-loading="loading">
       <div class="case_list_box">
            <div class="top_box">
                <img src="@/assets/img/login/Frame.png" alt="">
                <span class="span1" @click="handle_home">首页</span>
                > 案例库
            </div>
            <div class="check_box">
                <div class="check_felx">
                    <div class="check_title">纠纷发生地</div>
                    <div class="check_list" :class="{'check_list_minh':jffsd_show,'check_list_maxh':!jffsd_show}">
                        <div class="check_item" :class="{check_item_ac:item.id==jffsd_ac.id}" v-for="(item,index) in jffsd_list" :key="index" @click="handle_jffsd_ac(item)">{{ item.name }}</div>
                    </div>
                    <div class="check_show" :class="{'check_show2':jffsd_show}" @click="handle_jffsd_show">
                        <img src="@/assets/img/index/legal/check_show.png" alt="">
                    </div>
                </div>
                <div class="check_felx">
                    <div class="check_title">委托人住所地</div>
                    <div class="check_list" :class="{'check_list_minh':wtrszd_show,'check_list_maxh':!wtrszd_show}">
                        <div class="check_item" :class="{check_item_ac:item.id==wtrszd_ac.id}" v-for="(item,index) in wtrszd_list" :key="index" @click="handle_wtrszd_ac(item)">{{ item.name }}</div>
                    </div>
                    <div class="check_show" :class="{'check_show2':wtrszd_show}" @click="handle_wtrszd_show">
                        <img src="@/assets/img/index/legal/check_show.png" alt="">
                    </div>
                </div>
                <div class="check_felx">
                    <div class="check_title">一级分类</div>
                    <div class="check_list" :class="{'check_list_minh':yjfl_show,'check_list_maxh':!yjfl_show}" >
                        <div class="check_item" :class="{check_item_ac:item.id==yjfl_ac.id}" v-for="(item,index) in yjfl_list" :key="index" @click="handle_yjfl_ac(item)">{{ item.title }}</div>
                    </div>
                    <div class="check_show" :class="{'check_show2':yjfl_show}" @click="handle_yjfl_show">
                        <img src="@/assets/img/index/legal/check_show.png" alt="">
                    </div>
                </div>
                <div class="check_felx">
                    <div class="check_title">二级分类</div>
                    <div class="check_list" :class="{'check_list_minh':ejfl_show,'check_list_maxh':!ejfl_show}">
                        <div class="check_item" :class="{check_item_ac:item.id==ejfl_ac.id}" v-for="(item,index) in ejfl_list" :key="index"  @click="handle_ejfl_ac(item)">{{ item.title  }}</div>
                    </div>
                    <div class="check_show" :class="{'check_show2':ejfl_show}" @click="handle_ejfl_show">
                        <img src="@/assets/img/index/legal/check_show.png" alt="">
                    </div>
                </div>
                <div class="check_felx">
                    <div class="check_title">三级分类</div>
                    <div class="check_list" :class="{'check_list_minh':sjfl_show,'check_list_maxh':!sjfl_show}" >
                        <div class="check_item" :class="{check_item_ac:item.id==sjfl_ac.id}" v-for="(item,index) in sjfl_list" :key="index" @click="handle_sjfl_ac(item)">{{ item.title  }}</div>
                    </div>
                    <div class="check_show" :class="{'check_show2':sjfl_show}" @click="handle_sjfl_show">
                        <img src="@/assets/img/index/legal/check_show.png" alt="">
                    </div>
                </div>

                <div class="check_felx">
                    <div class="check_title">已选择</div>
                    <div class="check_ac_flex">
                        <div class="check_ac_box" v-if="jffsd_ac.id">
                            {{ jffsd_ac.name }}
                            <img src="@/assets/img/login/clear.png" alt="" @click="ac_clear('jffsd_ac')">
                        </div>
                        <div class="check_ac_box" v-if="wtrszd_ac.id">
                            {{ wtrszd_ac.name }}
                            <img src="@/assets/img/login/clear.png" alt="" @click="ac_clear('wtrszd_ac')">
                        </div>
                        <div class="check_ac_box" v-if="yjfl_ac.id">
                            {{ yjfl_ac.title }}
                            <img src="@/assets/img/login/clear.png" alt="" @click="ac_clear('yjfl_ac')">
                        </div>
                        <div class="check_ac_box" v-if="ejfl_ac.id">
                            {{ ejfl_ac.title }}
                            <img src="@/assets/img/login/clear.png" alt="" @click="ac_clear('ejfl_ac')">
                        </div>
                        <div class="check_ac_box" v-if="sjfl_ac.id">
                            {{ sjfl_ac.title }}
                            <img src="@/assets/img/login/clear.png" alt="" @click="ac_clear('sjfl_ac')">
                        </div>
                        <!-- <div class="check_ac_text"></div> -->
                        <div class="chack_ac_clear" @click="handle_clear">清空</div>
                    </div>
                </div>
            </div>
            <div class="list_box">
                <div class="list_flex">
                    <div class="item_list" v-for="(item,index) in list" :key="index" @click="handle_detial(item)">
                        <div class="item_titles">
                            {{ item.title }}
                        </div>
                        <div class="item_consts">
                            {{ item.desc }}
                        </div>
                        <div class="item_borders"></div>
                        <div class="item_btns">
                            <div class="btns1">
                                <img src="../../../assets/img/index/comments_case/see.png" alt="">
                                {{ item.views }}
                            </div>
                            <div class="btns2">
                                <img src="../../../assets/img/index/comments_case/pl_num.png" alt="">
                                {{ item.comment_num }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pages_box">
                    <div class="btns" @click="handle_pages(1)">首页</div>
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pages.page"
                        background
                        :page-size="pages.limit"
                        layout="prev, pager, next"
                        :total="total">
                    </el-pagination>
                    <div class="btns"  @click="handle_pages(10)">尾页</div>
                </div>
                  

            </div>
       </div>  
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'




export default {
    components: {
    },
    name: "homes",
    data() {
        return {
            loading:false,
            jffsd_list:[],//纠纷发生地列表
            jffsd_ac:{},//纠纷发生地选中
            jffsd_show:false,//纠纷发生地的显示隐藏
            
            wtrszd_list:[],//委托人住所地列表
            wtrszd_ac:{},//委托人住所地选中
            wtrszd_show:false,//委托人住所地的显示隐藏

            yjfl_list:[],//一级分类列表
            yjfl_ac:{},//一级分类选中
            yjfl_show:false,//一级分类的显示隐藏

            ejfl_list:[],//二级分类列表
            ejfl_ac:{},//二级分类选中
            ejfl_show:false,//二级分类的显示隐藏
            
            sjfl_list:[],//三级分类列表
            sjfl_ac:{},//三级分类选中
            sjfl_show:false,//三级分类的显示隐藏
            list:[],
            total:0,
            last_page:0,
            pages:{
                page:1,
                limit:10,
            },
            banner_ac:0,
            banner_list:[1,2,3]
          
        }
    },
    computed: {
       
    },
    watch: {
        
    },
    created() {
        this.get_list()
        this.get_area()
        this.get_cause_list()
    },
    methods: {
        get_area(){
            this.loading=true
            this.$api("getChinaArea", {
                parent_id:1,
				type:1,
			}, "get").then((res) => {
                this.loading = false
                console.log('地址',res)
                if (res.code == 1) {
                    this.jffsd_list=res.data
                    this.wtrszd_list=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        //获取分类
        get_cause_list(){
            this.loading=true
            this.$api("cause", {
				
			}, "get").then((res) => {
                this.loading = false
                console.log('案由',res)
                if (res.code == 1) {
                    this.yjfl_list=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handleSizeChange(e){
            console.log('条数',e)
        },
        handleCurrentChange(e){
            console.log(' 页数',e)
            this.pages.page=e
            this.get_list()
        },
        handle_pages(i){
            console.log('首页尾页',i)
            this.pages.page=i
            this.get_list()
        },
        handle_home(){
            this.$router.push({
                path:'/home',
            })
        },
        handle_jffsd_show(){
            this.jffsd_show=!this.jffsd_show
        },
        handle_wtrszd_show(){
            this.wtrszd_show=!this.wtrszd_show
        },
        handle_yjfl_show(){
            this.yjfl_show=!this.yjfl_show
        },
        handle_ejfl_show(){
            this.ejfl_show=!this.ejfl_show
        },
        handle_sjfl_show(){
            this.sjfl_show=!this.sjfl_show
        },
        change_banner(e){
            // console.log('却换触发',e)
            this.banner_ac=e
        },
        handle_jffsd_ac(item){
            this.jffsd_ac=item
            this.pages.page=1
            this.get_list()
        },
        handle_wtrszd_ac(item){
            this.wtrszd_ac=item
            this.pages.page=1
            this.get_list()
        },
        handle_yjfl_ac(item){
            this.yjfl_ac=item
            this.ejfl_list=item.child
            this.ejfl_ac={}
            this.sjfl_list=[]
            this.sjfl_ac={}
            this.pages.page=1
            this.get_list()
        },
        handle_ejfl_ac(item){
            this.ejfl_ac=item
            this.sjfl_list=item.child
            this.sjfl_ac={}
            this.pages.page=1
            this.get_list()
            
        },
        handle_sjfl_ac(item){
            this.sjfl_ac=item
            this.pages.page=1
            this.get_list()
        },
        ac_clear(text){
            this[text]={}
            if(text=='yjfl_ac'){
                this.ejfl_list=[]
                this.ejfl_ac={}
                this.sjfl_list=[]
                this.sjfl_ac={}
            }
            if(text=='ejfl_ac'){
                this.sjfl_list=[]
                this.sjfl_ac={}
            }
            this.pages.page=1
            this.get_list()
 
        },
        handle_clear(){
            this.jffsd_ac={}
            this.wtrszd_ac={}
            this.yjfl_ac={}
            this.ejfl_ac={}
            this.sjfl_ac={}
            this.ejfl_list=[]
            this.sjfl_list=[]
            this.pages.page=1
            this.get_list()
        },
        get_list(){
            this.loading = true
            this.$api("caseList", {
                anliku:1,//是否为案例库
                happen_province:this.jffsd_ac.id||'',//发生地所在省
                province:this.wtrszd_ac.id||'',//委托人所在省
                cateid:this.yjfl_ac.id||'',//一级分类
                cateid2:this.ejfl_ac.id||'',//二级费雷
                cateid3:this.sjfl_ac.id||'',//三级分类
                
			}, "get").then((res) => {
                this.loading = false
                console.log('案例库',res)
                if (res.code == 1) {
                   this.list=res.data.data
                   this.last_page=res.data.last_page
                   this.total=res.data.total
                } else {
                    alertErr(res.msg)
                }
            });
        },

        handle_detial(item){
            this.$api("getUserInfo", {
              
			}, "get").then((res) => {
                this.loading = false
                console.log('用户信息',res)
                if (res.code == 1) {
                    this.$router.push({
                        path:'/case_detial',
                        query:{
                            id:item.id
                        }
                    })
                } else {
                    alertErr(res.msg)
                    if(res.msg=='请登录'){
                        this.$router.push('/login')
                    }
                }
            });

            

        },
    },

}
</script>
<style scoped lang="less">
.case_list{
    padding-bottom: 100px;
    background-color: #F5F5F5;
    .case_list_box{
        width: 1440px;
        margin: auto;
        .top_box{
            display: flex;
            align-items: center;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            padding: 20px 0;

            .span1 {
                cursor: pointer;
            }

            img {
                width: 14px;
                height: 14px;
                margin-right: 10px;
            }
        }
        .check_box{
            width: 1440px;
            // height: 261px;
            background: #FFFFFF;
            border-radius: 0px 0px 0px 0px;
            padding:0 32px;
            .check_felx{
                display: flex;
                // align-items: center;
                padding: 24px 0px 14px 0;
                border-bottom: 1px solid #EEEEEE ;
                .check_title{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #999999;
                    width: 90px;
                    flex-shrink: 0;
                }
                .check_list{
                    display: flex;
                    flex-wrap: wrap;
                    width: 1260px;

                    .check_item{
                        cursor: pointer;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        margin-right: 40px;
                        margin-bottom: 10px;
                        &:hover{
                            color: #377CFD;
                        }
                    }
                    .check_item_ac{
                        color: #377CFD;

                    }
                }
                .check_list_maxh{
                    height: 60px;
                    overflow: hidden;
                }
                .check_list_minh{
                    min-height: 60px;
                }
                .check_show{
                    width: 20px;
                    height: 20px;
                    flex-shrink: 0;
                    img{
                        width: 20px;
                        height: 20px;
                        cursor: pointer;
                    }
                }
                .check_show2{
                    img{
                        transform: rotate(-180deg);
                    }
                }
                .check_ac_flex{
                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;
                    .check_ac_box{
                        // width: 102px;
                        padding: 0 10px;
                        height: 29px;
                        background: #F8F8F8;
                        border-radius: 0px 0px 0px 0px;
                        margin-right: 11px;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        
                        font-weight: 400;
                        font-size: 14px;
                        color: #656565;
                        img{
                            width: 12px;
                            height: 12px;
                            margin-left: 14px;
                            cursor: pointer;
                        }

                    }
                    .chack_ac_clear{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;
                        cursor: pointer;
                    }
                }
            }
        }
        .list_box{
            margin-top:20px ;
            .list_flex{
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                justify-content: space-between;
                .item_list{
                    width: 708px;
                    min-height: 236px;
                    background: #FFFFFF;
                    border-radius: 8px 8px 8px 8px;
                    margin-bottom: 20px;
                    padding: 32px 40px;
                    cursor: pointer;
                    .item_titles{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 20px;
                        color: #333333;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 1;
                        -webkit-box-orient: vertical;
                    }
                    .item_consts{
                        margin-top: 20px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }
                    .item_borders{
                        margin-top: 26px;
                        border-bottom: 1px solid #EDEDED;
                    }
                    .item_btns{
                        display: flex;
                        align-items: center;
                        padding-top: 26px;
                        .btns1{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #999999;
                            margin-right:24px ;
                            img{
                                width: 25px;
                                // height: 15px;
                            }
                        }
                        .btns2{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #999999;
                            img{
                                width: 20px;
                                // height: 15px;
                            }
                        }
                    }
                }
            }
            .pages_box{
                width: 100%;
                height: 100px;
                // background-color: red;
                display: flex;
                align-items: center;
                justify-content: center;
                /deep/.el-pagination{
                    .el-pager{
                        .number {
                            background-color: #FFFFFF;
                            border: 1px solid #EEEEEE;
                        }
                        .active{
                            background-color: #377CFD;
                        }
                    }
                }
                .btns{
                    width: 40px;
                    height: 32px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #EEEEEE;  
                    font-family: PingFang-SC-Medium, PingFang-SC-Medium;
                    font-weight: normal;
                    font-size: 14px;
                    color: #7A7A7A;
                    text-align: center;
                    line-height: 32px;
                    cursor: pointer;
                }
            }
        }
    }
    
   
    
}

</style>